import { openDB } from 'idb';

const LEGACY_DB = 'keyval-store';
const LEGACY_STORE = 'keyval';
const LEGACY_KEY = 'vuex';

const NEW_DB = 'vuex-db';
const NEW_STORE = 'vuex-store';

export async function migrateLegacyVuexState() {

    try {
        // Open legacy IndexedDB
        const legacyDb = await openDB(LEGACY_DB, 1);
        const oldState = await legacyDb.get(LEGACY_STORE, LEGACY_KEY);

        if (!oldState) {
            return;
        }

        // Open or create new transactional IndexedDB
        const newDb = await openDB(NEW_DB, 1, {
            upgrade(db) {
                if (!db.objectStoreNames.contains(NEW_STORE)) {
                    db.createObjectStore(NEW_STORE);
                }
            }
        });

        // Store legacy state in the new DB
        const tx = newDb.transaction(NEW_STORE, 'readwrite');
        await tx.store.put(oldState, LEGACY_KEY);
        await tx.done;

        // Optional: delete old data
        await legacyDb.delete(LEGACY_STORE, LEGACY_KEY);
    } catch (err) {
    }
}
